angular.module('app')
    .controller('MyContractsCtrl', function ($scope) {

        $scope.onPressSearch = function (value) {
            $scope.filter = value
        }

        $scope.onObtainingDropDowns = function (value) {
            $scope.modelToGetDropdowns = value;
            $scope.$broadcast("contractsReady");
        }

        $scope.restIsPending = function (value) {
            $scope.loaderRestCalling = value;
        }
    })